import { ManagerSettableStatusSchema, type ManagerSettableStatus, type PostStatus } from './posts';

/**
 * Egykattintásos „következő lépés” a kártyán: az állapotból a következő
 * KÉZZEL beállítható állapot, vagy `null`, ha nincs gomb (ügyfélnél lévő,
 * elutasított, generáló vagy publikált poszt). Egy forrás a webnek és az API-nak.
 *
 * A `ManagerSettableStatusSchema` a beállítható állapotok kanonikus
 * listája; nincs párhuzamos kézi unió.
 */
const NEXT_STEP: Partial<Record<PostStatus, ManagerSettableStatus>> = {
  draft_topic: 'topic_approved',
  topic_changes_requested: 'draft_topic',
  topic_approved: 'content_review',
  content_review: 'content_approved',
  content_changes_requested: 'content_review',
  content_approved: 'ready_to_publish',
  ready_to_publish: 'scheduled',
  scheduled: 'published',
};

export function nextStep(
  status: PostStatus,
  waitingInfoFrom: PostStatus | null | undefined,
): ManagerSettableStatus | null {
  if (status === 'waiting_info') {
    // Back to `waiting_info` itself would be a no-op button.
    if (waitingInfoFrom === 'waiting_info') return null;
    const parsed = ManagerSettableStatusSchema.safeParse(waitingInfoFrom);
    return parsed.success ? parsed.data : null;
  }
  return NEXT_STEP[status] ?? null;
}
